import { render, staticRenderFns } from "./PurchaseLicense.vue?vue&type=template&id=23a83393&scoped=true&"
import script from "./PurchaseLicense.vue?vue&type=script&lang=js&"
export * from "./PurchaseLicense.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseLicense.vue?vue&type=style&index=0&id=23a83393&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a83393",
  null
  
)

export default component.exports